module.exports = __webpack_public_path__ + "img/1.f3dfca15.png";